export default {
//  isLogin: ''
    appVersion:"",
    apiKey:window.yunweiConfig.apiKey,
    appCode:""
}



// WEBPACK FOOTER //
// ./src/store/state/state.js